var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.32031,
    width: 15.1959,
    height: 15.0318,
    rx: 2.25,
    stroke: "#202020",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.79346,
    y: 2.35352,
    width: 13.1089,
    height: 12.9653,
    rx: 1.75,
    stroke: "#EE3124",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.04346,
    y: 1.60352,
    width: 14.6089,
    height: 14.4653,
    rx: 2.5,
    fill: "#E84247"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26074 6.94735C6.26074 5.39749 7.30424 4.36426 8.34774 4.36426C9.39124 4.36426 10.4347 5.39749 10.4347 6.94735C10.4347 8.4972 9.39124 10.5637 8.34774 10.5637C7.30424 10.5637 6.26074 8.4972 6.26074 6.94735ZM7.30436 12.6301C7.30436 12.0595 7.77154 11.5969 8.34785 11.5969C8.92416 11.5969 9.39135 12.0595 9.39135 12.6301C9.39135 13.2008 8.92416 13.6634 8.34785 13.6634C7.77154 13.6634 7.30436 13.2008 7.30436 12.6301Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.255617131e8f8991c5e304c252ffb0c9.svg";
export { ForwardRef as ReactComponent };